import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import Styles from "./newsSearchPreview.lit.scss";
import {Search} from "../search";
import {resolve} from "../../../../container";
import {NewsSearchBackend} from "../newsSearchBackend";

@customElement("eop-news-search-preview")
export class EopNewsSearchPreview extends Search {

    public static readonly styles = Styles;

    @property({attribute: "url"})
    private resultsPageUrl: string;

    public constructor(backend: NewsSearchBackend = resolve(NewsSearchBackend)) {
        super(false);
        this.searchFacade.registerBackend(backend);
    }


    public render(): TemplateResult {
        return html`
            <eop-overlay-image-spinner event="search" class="content-search-spinner"></eop-overlay-image-spinner>
            <eop-overlay-spinner event="more"></eop-overlay-spinner>
            <eop-news-search-preview-tiles .resultsPageUrl=${this.resultsPageUrl} class="tiles"></eop-news-search-preview-tiles>
            <div class="footer">
                ${this.renderMoreButton()}
            </div>`;
    }
}
